import { createBrowserHistory } from 'history';
import qs, { IParseOptions } from 'qs';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { encoder, filterEmpty } from './utils';

export const history = createBrowserHistory();

export interface IQueryParams {
  loginAsDemo?: boolean;
}

export const generateQuerystring = <T = IQueryParams>(params?: T) => {
  return qs.stringify(params, { addQueryPrefix: true, filter: filterEmpty, encoder });
};

export const navigate = <T = IQueryParams>(pathname: string, params?: T): void => {
  const query = generateQuerystring(params);

  history.push(pathname + query);
};

export const goToLocation = <T = IQueryParams>(pathname: string, params?: T): void => {
  const query = generateQuerystring(params);

  location.pathname = pathname + query;
};

export const useWebQueryParams = (options?: IParseOptions): IQueryParams => {
  const location = useLocation();
  const search = location.search;

  const [memoOptions] = React.useState(options);

  return React.useMemo(() => qs.parse(search, { ...memoOptions, ignoreQueryPrefix: true }), [search, memoOptions]);
};

export const goBack = (): void => {
  history.goBack();
};

export const getLastUrlSegment = <T extends string | undefined>(): T => window.location.pathname.split('/').pop() as T;
